/**
 * @memberof ux-tread-dotcom-utils
 * @returns {object} returns window.document or an empty object
 */
export default function getDocument() {
  return document || {};
}